module.exports = __webpack_public_path__ + "img/poster-placeholder-video.3a86f021.jpg";